import Button from '@Components/Buttons/Button'
import React from 'react'
import { SongwriterUpdateRequestFormData } from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar'

interface EditWriterNameProps {
    onBack(): void
    setIsReviewing(isReviewing: boolean): void
    misspelling: SongwriterUpdateRequestFormData
    setMisspelling(misspelling: SongwriterUpdateRequestFormData): void
}

const EditWriterName = (props: EditWriterNameProps) => {
    const { onBack, setIsReviewing, misspelling, setMisspelling } = props
    return (
        <>
            <h2>Edit Writer Name</h2>
            <p> Help us correct your writer name.</p>
            <p>Sometimes names get misspelled. Let us know the correct version so we can fix it.</p>
            <div>
                <p>Please list the correct spelling below.</p>
                <textarea
                    value={misspelling.correctSpelling}
                    onChange={(e) => setMisspelling({ ...misspelling, correctSpelling: e.target.value })}
                />
            </div>
            <div>
                <p>Reason for correction</p>
                <textarea
                    value={misspelling.reasonForCorrection}
                    onChange={(e) => setMisspelling({ ...misspelling, reasonForCorrection: e.target.value })}
                />
                <p className="text-label">
                    Please explain what is wrong with the current spelling - is it a typo, a completely different
                    person, or something else?
                </p>
            </div>
            <div className="footer-buttons">
                <Button mainColor type="secondary" onClick={onBack}>
                    Back
                </Button>

                <Button
                    mainColor
                    type="primary"
                    disabled={!(misspelling.correctSpelling && misspelling.reasonForCorrection)}
                    onClick={() => setIsReviewing(true)}
                >
                    Review
                </Button>
            </div>
        </>
    )
}
export default EditWriterName
